import React, { PureComponent } from 'react'
import { drlLevelLabel } from '../../config/drlThresholds'

const COLORS = {
  ok: '#2e7d32',
  caution: '#f9a825',
  high: '#c62828',
  unknown: '#607d8b',
}

/**
 * Badge/semáforo de dosis en chrome.
 */
export default class DoseBadge extends PureComponent {
  render() {
    const { report, onClick } = this.props
    if (!report) return null

    const level = report.drlLevel || 'unknown'
    const color = COLORS[level] || COLORS.unknown
    const dlp = report.totals && report.totals.dlp
    const dap = report.totals && report.totals.dap
    const ctdi = report.totals && report.totals.ctdivol

    let valueLabel = 'Dosis'
    if (dlp != null) valueLabel = `DLP ${Math.round(dlp)}`
    else if (dap != null) valueLabel = `DAP ${Number(dap).toFixed(1)}`
    else if (ctdi != null) valueLabel = `CTDI ${Number(ctdi).toFixed(1)}`

    return (
      <button
        type="button"
        title={drlLevelLabel(level)}
        onClick={onClick}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '4px 10px',
          borderRadius: 4,
          border: `1px solid ${color}`,
          background: 'rgba(0,0,0,0.45)',
          color: '#f5f7fa',
          cursor: 'pointer',
          fontSize: 12,
          lineHeight: 1.2,
        }}
      >
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: color,
            display: 'inline-block',
          }}
        />
        <span>{valueLabel}</span>
      </button>
    )
  }
}
